import { render, staticRenderFns } from "./EndEventTab.vue?vue&type=template&id=7dd1075f&scoped=true&"
import script from "./EndEventTab.vue?vue&type=script&lang=js&"
export * from "./EndEventTab.vue?vue&type=script&lang=js&"
import style0 from "./EndEventTab.vue?vue&type=style&index=0&id=7dd1075f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd1075f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCol,VDivider,VRow,VSwitch})
